module.exports = __webpack_public_path__ + "static/media/Shiftry_gaussian2.70c1254f.png";